/**
 * Utils for getting relative date strings
 */
import _ from "lodash";

import dateSubtractionFunctions from "./dateSubtractionFunctions";

const secondsBetweenTS = dateSubtractionFunctions.secondsBetweenTS;
const minutesBetweenTS = dateSubtractionFunctions.minutesBetweenTS;
const hoursBetweenTS = dateSubtractionFunctions.hoursBetweenTS;

const getSecondsSinceZeroDate = (calendar, date) => {
  if (!_.isNil(calendar.zeroDateTimestamp)) {
    return secondsBetweenTS(calendar.zeroDateTimestamp, date.get("timestamp"));
  } else {
    return 0; // wrong, but to prevent crashing
  }
};

const getMinutesSinceZeroDate = (calendar, date) => {
  if (!_.isNil(calendar.zeroDateTimestamp)) {
    return minutesBetweenTS(calendar.zeroDateTimestamp, date.get("timestamp"));
  } else {
    return 0; // wrong, but to prevent crashing
  }
};

const getHoursSinceZeroDate = (calendar, date) => {
  if (!_.isNil(calendar.zeroDateTimestamp)) {
    return hoursBetweenTS(calendar.zeroDateTimestamp, date.get("timestamp"));
  } else {
    return 0; // wrong, but to prevent crashing
  }
};

/**
 * No day zero
 * Either >= day 1 or <= day -1
 * @param {CalendarRecord} calendar
 * @param {DateRecord} date
 */
const getDaysSinceZeroDate = (calendar, date) => {
  if (!_.isNil(calendar.zeroDateTimestamp)) {
    const day = getSecondsSinceZeroDate(calendar, date) / (calendar.hoursInDay * 3600);
    return Math.floor(day);
  } else {
    return 0; // wrong, but to prevent crashing
  }
};

/**
 * No week zero
 * Either >= week 1 or <= week -1
 * @param {CalendarRecord} calendar
 * @param {DateRecord} date
 */
const getWeeksSinceZeroDate = (calendar, date) => {
  if (!_.isNil(calendar.zeroDateTimestamp)) {
    const week = getSecondsSinceZeroDate(calendar, date) / (calendar.weekdays.size * calendar.hoursInDay * 3600);
    return Math.floor(week);
  } else {
    return 0; // wrong, but to prevent crashing
  }
};

export {
  getDaysSinceZeroDate,
  getHoursSinceZeroDate,
  getMinutesSinceZeroDate,
  getSecondsSinceZeroDate,
  getWeeksSinceZeroDate
};
